// src/utils/constants.js

export const TENDER_STATUSES = [
  { value: 'identified',  label: 'Identified' },
  { value: 'evaluating',  label: 'Evaluating' },
  { value: 'go',          label: 'Go' },
  { value: 'no_go',       label: 'No-Go' },
  { value: 'bidding',     label: 'Bidding' },
  { value: 'submitted',   label: 'Submitted' },
  { value: 'won',         label: 'Won' },
  { value: 'lost',        label: 'Lost' },
  { value: 'cancelled',   label: 'Cancelled' },
];

export const TENDER_SECTORS = [
  { value: 'underground_mining',   label: 'Underground Mining' },
  { value: 'oil_gas',              label: 'Oil & Gas' },
  { value: 'heavy_industrial',     label: 'Heavy Industrial' },
  { value: 'indigenous_partnership', label: 'Indigenous Partnership' },
  { value: 'consulting',           label: 'Consulting' },
  { value: 'green_energy',         label: 'Green Energy' },
  { value: 'decommissioning',      label: 'Decommissioning' },
  { value: 'other',                label: 'Other' },
];

export const TENDER_SOURCES = [
  { value: 'government_portal',    label: 'Government Portal' },
  { value: 'email',                label: 'Email Notification' },
  { value: 'manual_research',      label: 'Manual Research' },
  { value: 'industry_platform',    label: 'Industry Platform' },
  { value: 'direct_invitation',    label: 'Direct Invitation' },
  { value: 'other',                label: 'Other' },
];

export const PRIORITIES = [
  { value: 'low',      label: 'Low' },
  { value: 'medium',   label: 'Medium' },
  { value: 'high',     label: 'High' },
  { value: 'critical', label: 'Critical' },
];

export const CLIENT_TYPES = [
  { value: 'mine_operator',  label: 'Mine Operator' },
  { value: 'epcm',           label: 'EPCM' },
  { value: 'indigenous_org', label: 'Indigenous Organization' },
  { value: 'government',     label: 'Government' },
  { value: 'other',          label: 'Other' },
];

export const USER_ROLES = [
  { value: 'admin',   label: 'Admin' },
  { value: 'manager', label: 'Manager' },
  { value: 'viewer',  label: 'Viewer' },
];

export function formatCurrency(val, currency = 'CAD') {
  if (!val) return '—';
  return new Intl.NumberFormat('en-CA', { style: 'currency', currency, maximumFractionDigits: 0 }).format(val);
}

export function formatDate(d) {
  if (!d) return '—';
  return new Date(d + 'T00:00:00').toLocaleDateString('en-CA', { year:'numeric', month:'short', day:'numeric' });
}

export function getLabelFor(arr, value) {
  return arr.find(i => i.value === value)?.label ?? value ?? '—';
}

export function daysUntilColor(days) {
  if (days === null || days === undefined) return 'var(--text-muted)';
  if (days < 0)  return 'var(--red)';
  if (days <= 7) return 'var(--red)';
  if (days <= 14) return 'var(--orange)';
  return 'var(--text-secondary)';
}
